<aumico-table
    [options]="options"
    [data]="data"
    [delegate]="this"
    [filterSubject]="filterSubject"
    [userPreferredNumberOfDocumentsPerPage]="userPreferredNumberOfDocumentsPerPage"
    detachPager="true"
    (pageSizeChanged)="onPageSizeChanged($event)"
>
</aumico-table>
